import * as React from "react";
import { TimePicker } from "./time-picker";
import { Label } from "./label";

interface TimePickerRangeProps {
  checkInTime: string;
  checkOutTime: string;
  onCheckInTimeChange: (time: string) => void;
  onCheckOutTimeChange: (time: string) => void;
  checkInLabel?: string;
  checkOutLabel?: string;
  checkInPlaceholder?: string;
  checkOutPlaceholder?: string;
  className?: string;
  hasError?: boolean;
}

const TimePickerRange = React.forwardRef<HTMLDivElement, TimePickerRangeProps>(
  ({ 
    checkInTime, 
    checkOutTime, 
    onCheckInTimeChange, 
    onCheckOutTimeChange,
    checkInLabel = "Check-in Time",
    checkInPlaceholder = "Check-in",
    checkOutLabel = "Check-out Time",
    checkOutPlaceholder = "Check-out",
    className,
    hasError = false,
    ...props 
  }, ref) => {
    return (
      <div ref={ref} className={className} {...props}>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label htmlFor="checkInTime">{checkInLabel}</Label>
            <TimePicker
              placeholder={checkInPlaceholder}
              value={checkInTime}
              onChange={onCheckInTimeChange}
              hasError={hasError}
            />
          </div>
          <div>
            <Label htmlFor="checkOutTime">{checkOutLabel}</Label>
            <TimePicker
              placeholder={checkOutPlaceholder}
              value={checkOutTime}
              onChange={onCheckOutTimeChange}
              hasError={hasError}
            />
          </div>
        </div>
      </div>
    );
  }
);

TimePickerRange.displayName = "TimePickerRange";

export { TimePickerRange };
